// ── Pattern « carte univers » ────────────────────────────────────────────────
// Carte cliquable qui INCARNE son univers couleur (vert entreprendre · rose
// mode de vie · bleu immobilier) au lieu de ne colorer que le texte :
// - fond dégradé subtil teinté par l'accent + halo radial décoratif (coin droit)
// - bordure teintée, pastille d'icône colorée avec glow doux
// - hover : lift -4px + ombre colorée douce + halo renforcé ; active: scale tactile
// - transform/box-shadow uniquement (pas de layout shift), carte entière cliquable
// Utilisé sur : Home (accès rapides) et /contact (aiguillage). Voir PRD.md.
import { Link } from "react-router-dom";

export const UniverseCard = ({ to, accent, testid, className = "", children }) => (
  <Link
    to={to}
    data-testid={testid}
    style={{
      "--uc-sh": `${accent}2B`,
      "--uc-bd": `${accent}33`,
      "--uc-bdh": `${accent}7A`,
      background: `linear-gradient(135deg, ${accent}17 0%, ${accent}08 48%, rgba(255,255,255,0.92) 100%)`,
    }}
    className={`group relative block h-full overflow-hidden rounded-2xl border border-[var(--uc-bd)] transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-[var(--uc-bdh)] hover:shadow-[0_22px_55px_var(--uc-sh)] active:translate-y-0 active:scale-[0.99] ${className}`}
  >
    <span
      aria-hidden="true"
      className="pointer-events-none absolute -right-12 -top-14 h-44 w-44 rounded-full opacity-70 blur-2xl transition-opacity duration-500 group-hover:opacity-100"
      style={{ background: `radial-gradient(circle, ${accent}38, transparent 70%)` }}
    />
    {children}
  </Link>
);

// Pastille d'icône colorée par univers, avec glow doux et scale au hover du groupe.
export const UniverseIcon = ({ accent, Icon, className = "h-11 w-11", iconClassName = "h-5 w-5" }) => (
  <span
    className={`relative inline-flex shrink-0 items-center justify-center rounded-xl text-white transition-transform duration-300 group-hover:scale-110 ${className}`}
    style={{ backgroundColor: accent, boxShadow: `0 10px 26px ${accent}52` }}
  >
    <Icon className={iconClassName} />
  </span>
);
